// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"884d138e","47":"f70819ea","593":"f06035d7","860":"e49148e4"}[chunkId] + ".chunk.css";
};